import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../lib/apiClient';
import { throwError } from '../../../redux/modules/messages/actions';
import { notify } from '../../toaster';
import { QUERY_KEY_HOOKS } from './useHooks';

type HookMutationVariables = {
  hookId: number;
};

export const useDeleteHook = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const intl = useIntl();
  return useMutation({
    mutationFn: ({ hookId }: HookMutationVariables) =>
      api.request(endpoints.hooks.delete(hookId)),

    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEY_HOOKS]);
      notify.default({
        title: intl.formatMessage({
          id: 'containers.message.extensionDeleted',
        }),
      });
    },

    onError: () => {
      dispatch(throwError('extensionUpdateFailed'));
    },
  });
};
